// Activity: how the inbox says who reacted to one's message.

import { t, tn } from "./i18n";

// reactors names who reacted, newest first, each once: "Maya", "Maya and
// Sam", "Maya, Sam and 2 others".
export function reactors(names: string[]): string {
  const once = [...new Set(names)];
  if (once.length < 2) return once.join("");
  if (once.length === 2) return t("{a} and {b}", { a: once[0], b: once[1] });
  return tn(once.length - 2, "{a}, {b} and {n} other", "{a}, {b} and {n} others", { a: once[0], b: once[1] });
}

// reactedWith is the emoji used, each once, newest first.
export function reactedWith(list: { emoji: string }[]): string[] {
  return [...new Set(list.map((r) => r.emoji))];
}
